import AreaUnitStore from '../../../shared/features/areaUnit/areaUnitStore';
import CountriesStore from '../../../shared/features/countries/CountriesStore';
import PriceConfigStore from '../../../shared/features/priceConfig/PriceConfigStore';
import UserStore from '../../../shared/features/user/UserStore';
import UiStateStore from '../uiState/UiStateStore';

class RootStore {
  userStore: UserStore<RootStore>;

  areaUnitStore: AreaUnitStore<RootStore>;

  uiStateStore: UiStateStore;

  priceConfigStore: PriceConfigStore<RootStore>;

  countriesStore: CountriesStore<RootStore>;

  constructor() {
    this.userStore = new UserStore(this);
    this.areaUnitStore = new AreaUnitStore(this);
    this.uiStateStore = new UiStateStore(this);
    this.priceConfigStore = new PriceConfigStore(this);
    this.countriesStore = new CountriesStore(this);
  }
}

const rootStore = new RootStore();

export type IRootStore = typeof rootStore;

export default rootStore;
